import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductStateData } from "./productsSlice";

export type BucketItem = {
  product: ProductStateData;
  quantity: number;
};

const bucketStorageKey = "sangini_bucket";

const loadStoredBucket = (): BucketItem[] => {
  if (typeof window === "undefined") {
    return [];
  }

  const raw = window.localStorage.getItem(bucketStorageKey);
  if (!raw) {
    return [];
  }

  try {
    return JSON.parse(raw) as BucketItem[];
  } catch (error) {
    console.error("Failed to restore shopping bucket:", error);
    return [];
  }
};

const initialState: BucketItem[] = loadStoredBucket();

const shoppingBucketSlice = createSlice({
  name: "shoppingBucket",
  initialState,
  reducers: {
    hydrateBucket(_state, action: PayloadAction<BucketItem[]>) {
      return action.payload;
    },
    addToBucket(state, action: PayloadAction<ProductStateData>) {
      const index = state.findIndex((item) => item.product.id === action.payload.id);
      if (index !== -1) {
        state[index].quantity += 1;
        return state;
      }
      state.push({ product: action.payload, quantity: 1 });
      return state;
    },
    removeFromBucket(state, action: PayloadAction<string>) {
      return state.filter((item) => item.product.id !== action.payload);
    },
    setBucketQuantity(state, action: PayloadAction<{ productId: string; quantity: number }>) {
      const index = state.findIndex((item) => item.product.id === action.payload.productId);
      if (index === -1) {
        return state;
      }
      if (action.payload.quantity <= 0) {
        state.splice(index, 1);
        return state;
      }
      state[index].quantity = action.payload.quantity;
      return state;
    },
    clearBucket() {
      return [];
    },
  },
});

export const { hydrateBucket, addToBucket, removeFromBucket, setBucketQuantity, clearBucket } =
  shoppingBucketSlice.actions;
export default shoppingBucketSlice.reducer;
